import { hot } from 'react-hot-loader';
//import LinkExternal from '../components/Link/LinkExternal';
import './ButtonPrimary.scss';



function ButtonPrimary({ tag, label, onClick, disabled, style, /*color, to, size, type, icon,*/ }) {
  if (tag === "a")
    return (
      <div className="l-primary-button">
        <a href="/"
          className={
            "btn l-primary-button__button" +
            ' btn-color' +
            ' btn-md'
          }
        //:className="['btn-' + color, 'btn-' + size]"
        >
          <span>{label}</span>
        </a>
      </div>
    );

  if (tag === "button")
    return (
      <div className="l-primary-button">
        <button
          className={
            "btn l-primary-button__button" +
            ' btn-color' +
            ' btn-md' + // ?md
            ' btn-type-base' + //?base
            ' btn-icon-out'
          }
          //:className="['btn-' + color, 'btn-' + size, 'btn-type-' + type, 'btn-' + icon]"
          onClick={onClick}
          disabled={disabled}
          style={{ ...style }}
        >
          <span>{label}</span>
        </button>
      </div>
    );

  return null;
};

export default hot(module)(ButtonPrimary);
